

type Props = {};

const Copyright = (props: Props) => {
  return (
    <>
      <p
        className="copyright"
        data-aos="fade-up"
        data-aos-once="true"
      >
        <p
          className="my-0"
        >
          ©{" "}Eratek {new Date().getFullYear()}. All rights reserved
        </p>

        <p
          className="my-0"
        >
          Made with 💖 in Nigeria
        </p>
      </p>
    </>
  );
};

export default Copyright;
